<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col>
                <div class="pa-2 rounded elevation-1 bg-white">
                    <div>
                        <SportipsButton toPage="Administration" chevronLeft>Retour</SportipsButton>
                    </div>


                    <div class="text-h5 font-weight-bold my-2">Les liens groupes</div>
                    <div>Cette interface vous permet de créer un lien d'inscription pour vos groupe. Vous aurez la
                        possibilité de suivre les inscriptions de vos groupe ci-dessous.</div>
                    <LienGroupeInscriptionCreateForm @onCreate="onCreate"></LienGroupeInscriptionCreateForm>
                    <ListLienGroupeInscription :key="key_reload"></ListLienGroupeInscription>

                </div>



                <div>

                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import LienGroupeInscriptionCreateForm from "@/components/Administration/LiensGroupeInscription/CreateForm.vue";
import ListLienGroupeInscription from "@/components/Administration/LiensGroupeInscription/ListLiens.vue";
export default {
    components: { LienGroupeInscriptionCreateForm, ListLienGroupeInscription },
    data() {
        return {
            key_reload: 0,
            show_help_modal: false,
        };
    },
    computed: {},
    methods: {
        onCreate() {
            this.key_reload++;
        }
    },
    created() {

    },
}
</script>

<style lang="scss" scoped></style>